import { useState, useEffect } from 'react'
import { getSearchLineGAPI } from '../services/setting/attendance-noti'

export default function useSearchLineG(attendanceId, refreshKey) {
  const [data, setData] = useState([])

  useEffect(() => {
    if (!attendanceId) return

    const getData = async () => {
      const resp = await getSearchLineGAPI({ attendanceId })

      if (!resp) return

      if (resp.status) {
        setData(
          resp.result.map((d) => ({
            label: d?.lineGroupName ?? '',
            value: d?.notifyLineGroupId ?? '',
            lineGroupId: d?.lineGroupId ?? '',
            orgGroupId: d?.orgGroupId ?? '-',
          })),
        )
      } else {
        setData([])
      }
    }

    getData()
  }, [attendanceId, refreshKey])   // ⭐ เพิ่ม refreshKey

  return data
}
